import { render, staticRenderFns } from "./ExpensesViewDesktop.vue?vue&type=template&id=075d5063&"
import script from "./ExpensesViewDesktop.vue?vue&type=script&lang=js&"
export * from "./ExpensesViewDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesViewDesktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports